module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC2SURBVEhL7YyxDQJBEAOPhIicBuiAHiiCMqANyqAJeqCDb4AYIhLAlv5Wi2RxZ/QZjDTS/57t8nPsRidnBg/wOcpv3iZhDo+wjld54xupN5sFPME8nOUbM/XfYgnPMA8qc6abFRxgHuqxizW8QDXQkt2PbOAVqnKPN8gNyRbeoSo6coNbb+zhA6rCN3KLmxJVcGyiSo5NnJKTDZySkw2ckpMNnJKTDZySkw2ckpMNnJKT/aMo5QVgxtkJzXBjOAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-home/dark/24.png
// module id = 2150
// module chunks = 2